import global from "@/locales/hr-BA/global";
import error403 from "@/locales/hr-BA/errors/403";
import error404 from "@/locales/hr-BA/errors/404";
import error500 from "@/locales/hr-BA/errors/500";
import error503 from "@/locales/hr-BA/errors/503";
import error504 from "@/locales/hr-BA/errors/504";
import maintenance from "@/locales/hr-BA/auth/maintenance";
import toast from "@/locales/hr-BA/toast/toast";
import login from "@/locales/hr-BA/auth/login";
import onboarding from "@/locales/hr-BA/auth/onboarding";
import loginPageSteps from "@/locales/hr-BA/loginPageSteps";
import dashboard from "@/locales/hr-BA/dashboard/dashboard";
import account from "@/locales/hr-BA/account/account";
import mailbox from "@/locales/hr-BA/account/mailbox";
import bankstatement from "@/locales/hr-BA/account/bankstatement";
import myApps from "@/locales/hr-BA/my-apps/myApps";
import about from "@/locales/hr-BA/about/about";
import contactService from "@/locales/hr-BA/about/contactService";
import salesPromotions from "@/locales/hr-BA/sales/promotions";
import brochures from "@/locales/hr-BA/sales/brochures";
import shop from "@/locales/hr-BA/shop/data";
import priceList from "@/locales/hr-BA/shop/priceList";
import staff from "@/locales/hr-BA/dashboard/staff";
import promotions from "@/locales/hr-BA/promotions";
import points from "@/locales/hr-BA/points";
import trainings from "@/locales/hr-BA/trainings/trainings";
import vouchers from "@/locales/hr-BA/vouchers/vouchers";
import media from "@/locales/hr-BA/media/index";
import product from "@/locales/hr-BA/product/index";
import message from "@/locales/hr-BA/message/index";
import commitmentLetter from "@/locales/hr-BA/account/commitmentLetter";
import multiplicator from "@/locales/hr-BA/multiplicator";
import consents from "@/locales/hr-BA/consents/consents";
import investment from "@/locales/hr-BA/investment/data";
import kickback from "@/locales/hr-BA/kickback";
//prettier-ignore
const messages = {
  loginPageSteps: loginPageSteps.messages,
  global: global.messages,
  error403: error403.messages,
  error404: error404.messages,
  error500: error500.messages,
  error503: error503.messages,
  error504: error504.messages,
  maintenance: maintenance.messages,
  toast: toast.messages,
  login: login.messages,
  onboarding: onboarding.messages,
  dashboard: dashboard.messages,
  multiplicator: multiplicator.messages,
  account: account.messages,
  mailbox: mailbox.messages,
  myApps: myApps.messages,
  bankstatement: bankstatement.messages,
  about: about.messages,
  contactService: contactService.messages,
  salesPromotions: salesPromotions.messages,
  shop: shop.messages,
  staff: staff.messages,
  promotions: promotions.messages,
  points: points.messages,
  brochures: brochures.messages,
  trainings: trainings.messages,
  vouchers: vouchers.messages,
  media: media.messages,
  priceList: priceList.messages,
  productInfo: product.messages,
  message: message.messages,
  commitmentLetter: commitmentLetter.messages,
  consents: consents.messages,
  investment: investment.messages,
  kickback: kickback.messages,
  productBrochures: {
    BDriveTitle: "Slike proizvoda",
    BDriveLinkText: "Poveznica na portal SLIKA PROIZVODA",
  },
}

export default {
  locale: "hr-BA",
  messages,
};
